

























import CertificateRegistrationPopup from '@/components/popup/page/CertificateRegistration.vue'
import TypeSelectionPopup from '@/components/popup/btt/TypeSelection.vue'
import BankCodeSelectionPopup from '@/components/popup/btt/BankCodeSelection.vue'
import Translation from '@/mixins/Translation'
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import PopupHandlerMixin from '@/mixins/popupHandler'

const layout = namespace('layout')

@Component({
  components: {
    CertificateRegistrationPopup,
    BankCodeSelectionPopup,
    TypeSelectionPopup,
  },
})
export default
class BankEnablingPopups extends Mixins(Translation, PopupHandlerMixin) {
  /**
   * 공동인증서로 은행계좌를 등록하는 경우, 관련된 팝업 컴포넌트를 제어하는 wrapper component
   */
  @layout.Mutation('updateError') updateError

  /**
   * 팝업 실행을 위한 페이지에서 전달받는 Prop
   */
  @Prop({default: false, type: Boolean}) isOpen: boolean
  @Prop({default: false, type: Boolean}) openRegisterPopup: boolean
  @Prop({default: null, type: String}) serviceName: ''
  @Prop({default: 'terms'}) translation: string

  selectedCode: null | string = null

  @Watch('isOpen', {immediate: true})
  __isOpen(value) {
    this.setPopupStatus('bankCodeSelection', value)
  }

  @Watch('serviceName', {immediate: true})
  __serviceName(value) {
    this.selectedCode = value
  }

  @Watch('openRegisterPopup', {immediate: true})
  __openRegisterPopup(val) {
    this.setPopupStatus('certRegister', val)
  }

  onSelectCode(code) {
    this.selectedCode = code
    this.openPopup('certRegister')
  }

  onCloseCerts() {
    this.closePopup('certRegister')
    this.$emit('on-close-cert')
    this.selectedCode = null
  }

  close() {
    this.closePopup('bankCodeSelection')
    this.$emit('close')
  }
}
